<template>
  <div class="scale-calibration__container">
    <retractable-screen-coordinates>
      <div class="dpc-info__container">
        <div class="dpc-info__container--item">
          <label
            for="PPC-input"
            class="font-bold block mt-2"
          > Puntos Por Centímetro </label>
          <InputNumber
            v-model="dpcManual"
            input-id="PPC-input"
            class="dpc-info__info-box"
            suffix=" PPC"
            :max-fraction-digits="1"
            @update:model-value="setDPI"
          />
        </div>
        <div class="dpc-info__container--item">
          <label
            for="PPP-input"
            class="font-bold block mt-2 ml-2"
          > Puntos Por Pulgada </label>
          <InputNumber
            v-model="dpiManual"
            input-id="PPP-input"
            class="dpc-info__info-box"
            suffix=" PPP"
            :max-fraction-digits="1"
            @update:model-value="setDPC"
          />
        </div>
        <div class="dpc-info__container--controls">
          <Button
            :disabled="manualInputDisabled"
            @click="setManualDPC"
          >
            Guardar
          </Button>
          <Button @click="resetDefaultDPC">
            Restablecer
          </Button>
        </div>
      </div>
      <div class="dpc-info__container--help">
        <!-- eslint-disable max-len  -->
        <p>Calibrar la densidad física de píxeles es necesario para una representación exacta de las escalas del Mapa Oficial de Carretaras.</p>
        <p>Utilice la herramienta de medición física o, si conoce el dato, introduzca manualmente los PPP o PPC de su pantalla para asegurar una buena representación física de las escalas del mapa.</p>
        <!-- eslint-enable max-len  -->
      </div>
      <MeasureScaleCalibration @change-dpc="resetManualDPC" />
    </retractable-screen-coordinates>
  </div>
</template>

<script setup>
import {ref, computed, onMounted} from 'vue';
import {useStore} from 'vuex';
import Button from 'primevue/button';
import InputNumber from 'primevue/inputnumber';
import RetractableScreenCoordinates
  from '@/components/retractable-screen-coordinates/RetractableScreenCoordinates';
import {DEFAULT_SCREEN_DPI, dpc2dpi, dpi2dpc} from '@/util-scale';
import MeasureScaleCalibration from './MeasureScaleCalibration';
// #region Props, Emits

// #endregion

// #region Params, Ref, Reactives, Computed
const dpcManual = ref(0);
const dpiManual = ref(0);
const store = useStore();

const dpc = computed(() => store.state.map.screenDPC);
const manualInputDisabled = computed(() => dpc.value == dpcManual.value);

// #endregion

// #region Functions
function setDPI() {
  dpiManual.value = dpc2dpi(dpcManual.value);
}
function setDPC() {
  dpcManual.value = dpi2dpc(dpiManual.value);
}
function resetManualDPC() {
  dpcManual.value = dpc.value;
  setDPI();
}
async function resetDefaultDPC() {
  dpiManual.value = DEFAULT_SCREEN_DPI;
  setDPC();
  await store.dispatch('map/setScreenDPI', {screenDPI: DEFAULT_SCREEN_DPI}, {root: true});
  window.location.reload();
}
async function setManualDPC() {
  await store.dispatch('map/setScreenDPC', {screenDPC: dpcManual.value}, {root: true});
  window.location.reload();
}
// #endregion

// #region Effects, Hooks
onMounted(() => {
  resetManualDPC();
  setDPI();
});
// #endregion

// #region Provide, Expose

// #endregion
</script>

<style lang="scss" scoped>
@import "src/styles";
.scale-calibration {
  &__container {
    width: 100%;
  }
  &__title {
    max-width: 10rem;
    margin: 1rem auto;
  }
}
.dpc-info__container {
  display: flex;
  flex-direction: row;
  align-content: center;
  @include max-screen-width($brand__breakpoint--md) {
    flex-direction: column;
  }
  justify-content: space-evenly;
  flex-wrap: wrap;
  gap: 0.5rem;
  &--item {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-evenly;
    gap: 0.5rem;
  }
  &--controls {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    justify-content: space-evenly;
  }
  &--help {
    padding: 0 1rem;
  }
}
</style>
